import React, { Fragment } from 'react'
import injectStyles from 'react-jss'

import ButtonGroup from '@material-ui/core/ButtonGroup'
import SubmitButton from 'Components/Form/SubmitButton'
import { styles } from './styles'

const Presets = ({ presets, classes, onChangePreset, presetValue }) => {
  return (
    <Fragment>
      {presets && (
        <div className={classes.presets}>
          <ButtonGroup color="primary" className={classes.group}>
            {presets.map((item, i) => (
              <SubmitButton
                key={i}
                onClick={() => {
                  onChangePreset({ id: item.id, label: item.label })
                }}
                value={item.label}
                variant={presetValue === item.label ? 'contained' : 'outlined'}
              />
            ))}
          </ButtonGroup>
        </div>
      )}
    </Fragment>
  )
}

export default injectStyles(styles)(Presets)
